/**
 * CardSkeleton Component
 *
 * Skeleton loader for content cards with shimmer effect.
 * Used while loading PostCard, RSSContentCard, etc.
 */

import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";

function CardSkeleton({ hasImage = true, hasButton = false }) {
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      {/* Banner Image Skeleton */}
      {hasImage && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{
            width: "100%",
            height: { xs: 160, sm: 180, md: 200 },
          }}
        />
      )}

      <CardContent sx={{ flexGrow: 1, p: { xs: 2, sm: 2.5, md: 3 } }}>
        {/* Header with Badge and Date */}
        <MDBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton
            variant="rounded"
            animation="wave"
            width={80}
            height={24}
            sx={{ borderRadius: "12px" }}
          />
          <Skeleton variant="text" animation="wave" width={80} />
        </MDBox>

        {/* Title */}
        <MDBox mb={1.5}>
          <Skeleton variant="text" animation="wave" height={32} />
          <Skeleton variant="text" animation="wave" width="70%" height={32} />
        </MDBox>

        {/* Description */}
        <MDBox mb={2}>
          <Skeleton variant="text" animation="wave" />
          <Skeleton variant="text" animation="wave" />
          <Skeleton variant="text" animation="wave" width="60%" />
        </MDBox>

        {/* Source Channel Tag */}
        <Skeleton
          variant="rounded"
          animation="wave"
          width={100}
          height={22}
          sx={{ borderRadius: "12px" }}
        />
      </CardContent>

      {/* Button Skeleton */}
      {hasButton && (
        <MDBox p={{ xs: 2, sm: 2.5, md: 3 }} pt={0}>
          <Skeleton variant="rounded" animation="wave" height={44} sx={{ borderRadius: "8px" }} />
        </MDBox>
      )}
    </Card>
  );
}

CardSkeleton.propTypes = {
  hasImage: PropTypes.bool,
  hasButton: PropTypes.bool,
};

export default CardSkeleton;
